import React from 'react';
import cn from 'classnames';

import { extConfig } from '../../../Editor/presets/AttachmentCaption/config';
import type { ExternalReactRenderers } from '../../../Editor/types';
import Viewer from '../../Viewer';
import { Measureable } from '../../types';

import s from './AttachmentCaption.scss';

export interface Props extends Measureable {
  contentJson: any;
  className?: string;
  externalRenderers: ExternalReactRenderers;
}

const AttachmentCaptionViewer = React.forwardRef<HTMLDivElement, Props>(
  (
    { contentJson, className, externalRenderers, cookieType, defaultSize },
    ref
  ) => {
    return (
      <Viewer
        presetId="attachment-caption"
        contentJson={contentJson}
        className={cn(s['root'], className)}
        extensionConfig={extConfig}
        externalRenderers={externalRenderers}
        cookieType={cookieType}
        defaultSize={defaultSize}
        ref={ref}
      />
    );
  }
);
AttachmentCaptionViewer.displayName = 'AttachmentCaptionViewer';

export default AttachmentCaptionViewer;
